<!--
    描述：菜单接口管理--左侧组织架构
    时间：2020-04-30
    Created by yefan
-->
<template>
	<div class="h100">
		<div class="w-table-layout">
			<div class="w-table-content"
				 ref="menusContent">
				<el-table :data="menusTreeData.tableData"
						  row-key="id"
						  v-loading="menusTreeData.loading"
						  ref="menusTree"
						  default-expand-all
						  :height="menusTreeData.tableH"
						  border
						  highlight-current-row
						  @row-click="rowClick"
						  :tree-props="{children: 'children'}">
					<el-table-column prop="sname"
									 label="菜单名称"
									 show-overflow-tooltip
									 min-width="120"></el-table-column>
					<el-table-column prop="menuType"
									 label="操作"
									 align="center"
									 show-overflow-tooltip
									 width="60">
						<template slot-scope="scope">
							<el-button size="mini"
									   icon="el-icon-circle-plus"
									   title="添加关联接口"
									   v-if="roleBtns.includes('menu_interface_add')"
									   type="text"
									   @click="doClick(scope.row,'add')"></el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>

		<!-- 新增弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   :close-on-click-modal="false"
				   @closed="handleClose">
			<!-- 弹窗组件 -->
			<addInterface ref="addInterface"
						  v-if="dialogObj.visible"
						  :mode="dialogObj.mode"
						  :transObj="transObj"
						  @handle-success="handleSuccess"></addInterface>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="doSave">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { selectTree } from '@/api/modules/menu.js'
import addInterface from './add_interface_dialog'
export default {
	components: { addInterface },
	data() {
		return {
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '800px',
				mode: ''
			},
			transObj: {
				menuId: ''
			},

			menusTreeData: {
				loading: false,
				tableH: 200,
				tableData: []
			}
		}
	},
	methods: {
		getMenuTreeTableData() {
			let that = this
			let param = {}
			selectTree(param).then(res => {
				if (res.operationCode == 1) {
					that.menusTreeData.tableData = res.data
					this.$refs.menusTree.setCurrentRow(res.data[0])
					this.rowClick(res.data[0])
				}
			})
		},
		rowClick(obj) {
			this.$emit('row-click', obj)
		},
		doClick(obj, type) {
			let that = this
			that.dialogObj.mode = type
			if (type === 'add') {
				this.transObj.menuId = obj.id
				this.dialogObj.title = '添加关联接口'
				this.dialogObj.visible = true
			}
		},
		doSave() {
			this.$refs.addInterface.saveClick()
		},
		handleSuccess(obj) {
			this.dialogObj.visible = false
			let obj_ = { id: obj.menuId }
			this.$emit('row-click', obj_)
		},
		handleClose() {
			this.dialogObj.visible = false
		}
	},
	created() {
		this.getMenuTreeTableData()
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
    },
    // 进入缓存页面
    activated() {
        this.$nextTick(() => {
			setTimeout(() => {
				this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
    },
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	watch: {
		clientSize(val) {
			this.menusTreeData.tableH = this.$refs.menusContent.offsetHeight
		}
	}
}
</script>
<style lang="less">
</style>
